import { useState } from 'react';
import { Badge, Box, Button, Divider, Flex, Stack, Text } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { ReplaceFileModal } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Documents/components/ReplaceFileModal';

interface Props {
	dealId: string;
	programmeId: string;
	documentWorkflowInstanceId: string;
	fileName?: string | null;
	isReadOnly: boolean;
}

export const ReplaceFileSection = ({
	dealId,
	programmeId,
	documentWorkflowInstanceId,
	fileName,
	isReadOnly,
}: Props) => {
	const tMipManage = useTranslationMipManage();
	const [isModalOpen, setIsModalOpen] = useState(false);

	return (
		<>
			<Divider color="gray.2" />
			<Stack gap="sm">
				<Flex justify="space-between" align="center">
					<Text c="gray.9" size="0.875rem">
						File actions
					</Text>
					<Badge
						color="blue"
						variant="light"
						size="sm"
						radius="xl"
						leftSection={
							<Flex align="center">
								<Icon variant="verified-v3" size="md" />
							</Flex>
						}
						sx={{ fontWeight: 700 }}
					>
						SUPPORT
					</Badge>
				</Flex>
				<Box
					p="md"
					sx={(theme) => ({
						border: `1px solid ${theme.colors.gray[2]}`,
						borderRadius: theme.radius.sm,
					})}
				>
					<Stack gap="md">
						<Text size="0.875rem" c="gray.7" lh={1.5}>
							{isReadOnly
								? tMipManage(
										'documents_page.replace_file.section.description_review'
									)
								: tMipManage(
										'documents_page.replace_file.section.description_signing'
									)}
						</Text>
						<Button
							variant="default"
							size="md"
							leftSection={<Icon variant="document-v3" size="md" />}
							onClick={() => setIsModalOpen(true)}
							fullWidth
							styles={(theme) => ({
								root: {
									borderColor: theme.colors.gray[2],
									color: theme.colors.dark[9],
									fontWeight: 600,
								},
							})}
						>
							Replace file
						</Button>
					</Stack>
				</Box>
			</Stack>
			<ReplaceFileModal
				dealId={dealId}
				programmeId={programmeId}
				documentWorkflowInstanceId={documentWorkflowInstanceId}
				currentFileName={fileName}
				isReadOnly={isReadOnly}
				opened={isModalOpen}
				onClose={() => setIsModalOpen(false)}
			/>
		</>
	);
};
